<div class="account_items">
  @if (hasToken) {
    <div class="account_item no_border">
      @if (tanValidationEnabled) {
        <button (click)="onFetchToken()"><h3>Neuen Code bestellen</h3></button>
      }
    </div>
  } @else {
    <div class="account_item no_border">
      @if (tanValidationEnabled) {
        <button (click)="onFetchToken()"><h1>JETZT BIETEN</h1></button>
      }
    </div>
  }
  @if (!tanValidationEnabled || hasToken) {
    <div class="account_item no_border">
      @if (hasToken) {
        <div class="formrow">
          Du hast eben einen Code per SMS auf dein Mobile geschickt bekommen.<br>
        </div>
      }
      @if (showForm()) {
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          @if (tanValidationEnabled) {
            <div class="formrow">
              <label for="tan">SMS Code eingeben:</label>
              <input id="tan" type="text" formControlName="tan" class="form-control" required
                [ngClass]="{ 'is-invalid': submitted && f['tan'].errors }" />
              @if (submitted && f['tan'].errors) {
                <div class="invalid-feedback">
                  @if (f['tan'].errors['required']) {
                    <div>Der SMS Code muss eingegeben werden</div>
                  }
                </div>
              }
            </div>
          }
          <div class="formrow">
            <label for="amount">Dein Gebot in CHF eingeben:</label>
            <input id="amount" type="number" [min]="minimumBidAmount || 0" max="999999999" step="1" formControlName="amount" class="form-control" required
              [ngClass]="{ 'is-invalid': submitted && f['amount'].errors }" />
            @if (submitted && f['amount'].errors) {
              <div class="invalid-feedback">
                @if (f['amount'].errors['required']) {
                  <div>Ein Gebot muss eingegeben werden</div>
                }
                @if (exhibit.minimum_amount && (f['amount'].errors['min']) && ((minimumBidAmount || 0) <= exhibit.minimum_amount)) {
                  <div>Dein Gebot muss mindestens dem Startgebot entsprechen</div>
                }
                @if (exhibit.minimum_amount && f['amount'].errors['min'] && ((minimumBidAmount || 0) > exhibit.minimum_amount)) {
                  <div>Dein Gebot muss das aktuell höchste Gebot um mind. CHF {{ exhibit.bidding_step }} übertreffen</div>
                }
                @if (f['amount'].errors['max']) {
                  <div>Das Gebot darf nicht in Milliardenhöhe sein</div>
                }
                @if (f['amount'].errors['pattern']) {
                  <div>Das Gebot darf keine Rappen beinhalten</div>
                }
              </div>
            }
          </div>
          <div class="formrow">
            <button>
              <h1>GEBOT ABGEBEN</h1>
            </button>
          </div>
        </form>
      }
    </div>
  }
</div>